<script setup>

import { inject, ref, computed, watch } from 'vue';
import { getErreurValeurListeRequise } from '@/scripts/controlesSaisie.js';
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieListe from '@/components/generiques/SaisieListe.vue';
import ModaleAjoutDimension from '@/components/modales/ModaleAjoutDimension.vue';

const emit = defineEmits(['ajoutVariableDimension', 'fermeture']);

const { colonneSelectionnee } = defineProps({
    colonneSelectionnee: Object
});

const dimensions = inject('dimensions');

const variableDimension = ref({
    dimension: null,
    definitionValeursDimension: false
});
const nouvelleDimensionSuggeree = ref(null);

const dimensionsProposees = computed(() => {
    const dimensionsProposees = dimensions.value.slice();
    dimensionsProposees.push({
        nom: 'Nouvelle dimension...',
        nouvelleDimension: true
    });
    return dimensionsProposees;
});

watch(() => variableDimension.value.dimension, (dimension) => {
    if (dimension?.nouvelleDimension) {
        nouvelleDimensionSuggeree.value = {
            nom: colonneSelectionnee.nom,
            nomVariable: colonneSelectionnee.nom[0].toLowerCase(),
            typeDonnee: colonneSelectionnee.typeDonnee,
            modeEvaluation: 'SAISIE'
        };
    }
});

function validerSaisie() {
    const erreurs = {};
    erreurs.dimension = getErreurValeurListeRequise(variableDimension.value.dimension);
    return erreurs;
}

function validerFormulaire() {
    variableDimension.value.validationFormulaire = true;
}

function ajouterVariableDimension() {
    const infosAjoutVariableDimension = {
        nomColonne: colonneSelectionnee.nom,
        idDimension: variableDimension.value.dimension.id,
        definitionValeursDimension: variableDimension.value.definitionValeursDimension
    };
    emit('ajoutVariableDimension', infosAjoutVariableDimension);
}

function gererAjoutDimension(nomDimension) {
    variableDimension.value.dimension = dimensions.value.find(dim => dim.nom === nomDimension);
}

function gererFermeture(visible) {
    if (!visible) {
        emit('fermeture');
    }
}

</script>

<template>
    <Dialog 
        :visible="true" 
        modal 
        :header="'Identifier la valeur d\'une dimension à partir d\'une colonne du fichier'"
        @update:visible="gererFermeture">
            <Formulaire
                :objet="variableDimension"
                :fonction-validation-saisie="validerSaisie"
                @validation="ajouterVariableDimension">
                <label class="intitule titre type-objet">Colonne :</label>
                <label class="colonne-selectionnee">{{ colonneSelectionnee.nom }}</label>
                <label class="intitule titre type-objet">Dimension :</label>
                <SaisieListe 
                    v-model:valeur="variableDimension.dimension" 
                    id-erreur="dimension" 
                    :options="dimensionsProposees"
                    :option-label="'nom'" />
            </Formulaire>
            <div class="zone-definir-valeurs-dimension">
                <InputSwitch 
                    v-model="variableDimension.definitionValeursDimension" />
                <label class="intitule">Définir les valeurs de la dimension à partir de cette colonne</label>
            </div>
            <template #footer>
                <button 
                    class="bouton fas fa-check" 
                    :disabled="false"
                    @click="validerFormulaire()"/>
            </template>
    </Dialog>
    <ModaleAjoutDimension 
        v-if="nouvelleDimensionSuggeree"
        :dimension="nouvelleDimensionSuggeree"  
        @fermeture="nouvelleDimensionSuggeree = null"
        @ajout-dimension="(nomDimension) => gererAjoutDimension(nomDimension)" />
</template>

<style scoped>

.zone-definir-valeurs-dimension {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 15px;
    margin-right: 5px;
    float: right;
}

</style>